import React from "react";

const schedule = [
  {
    name: "Сүхбаатар",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Дорнод",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Хэнтий",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Дундговь",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Дорноговь",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Өмнөговь",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Говьсүмбэр",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Төв",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Орхон",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Булган",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Дархан-Уул",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Сэлэнгэ",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Хөвсгөл",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9h",
  },
  {
    name: "Архангай",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Өвөрхангай",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Баянхонгор",
    dateFrom: "2024.03.04",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Завхан",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Увс",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Говь-Алтай",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Баян-Өлгий",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Ховд",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
  {
    name: "Нийслэл",
    dateFrom: "2025.08.06",
    dateTo: "14:00",
    link: "https://forms.gle/v76beYW9D4s6GNpH9",
  },
];

export default function Schedule() {
  return (
    <div class="container">
      <div class="section-title mt-5" data-aos="fade-up">
        <h2>Хуваарь</h2>
        <p>ТӨСВИЙН ШИНЭЧЛЭЛ 2026 УУЛЗАЛТ</p>
      </div>
      <div className="att-table-container ">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>№</th>
              <th style={{ textAlign: "left" }}>Аймаг</th>
              <th style={{ textAlign: "left" }}>Уулзалт болох өдөр</th>
              <th style={{ textAlign: "left" }}>Эхлэх цаг</th>
              <th style={{ textAlign: "left" }}>Линк</th>
            </tr>
          </thead>
          <tbody>
            {schedule.map((el, i) => (
              <tr>
                <td>{i + 1}</td>
                <td>{el.name}</td>
                <td>{el.dateFrom}</td>
                <td>{el.dateTo}</td>
                <td>
                  <a
                    href={
                      el.link != ""
                        ? el.link
                        : "javascript:alert('Уулзалтын онлайн хурал эхлэх болоогүй');"
                    }
                    target={el.link != "" && "_blank"}
                  >
                    Оролцох
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
